import wasmAddonModule from "./liqaWasmAddon"
import wasm from "./liqaWasmAddon.wasm?url"
import type { WasmModule } from "./types"

let wasmModulePromise: Promise<WasmModule> | null = null

export function initWasmModule(): Promise<WasmModule> {
  if (!wasmModulePromise) {
    wasmModulePromise = wasmAddonModule({
      locateFile(_: string) {
        return wasm
      },
    }) as Promise<WasmModule>
  }
  return wasmModulePromise
}
